export const useToasts = () => {
  return {
    showToast: (message) => {
      // eslint-disable-next-line no-console
      console.log('Mock Toast shown:', message);
    },
  };
};
